import React, {Component} from "react"
import PropTypes from 'prop-types'
import Text from "../../Util/Text"
import ThreadFile from "../../Util/ThreadFile"
import {FormattedDate, FormattedMessage, FormattedTime} from 'react-intl';
import {parseDate} from '../../../../../assets/util';

const Attribute = ({attribute}) => {
    const value = attribute.value;

    switch (attribute.type) {
        case 'text':
        case 'string':
            return <Text content={value}/>;
        case 'number':
            return <span>{value}</span>;
        case 'time':
            return <FormattedTime value={parseDate(value)}/>;
        case 'boolean':
            return value
                ? <span><FormattedMessage id="yes"/></span>
                : <span><FormattedMessage id="no"/></span>;
        case 'date':
            return <FormattedDate value={parseDate(value)}/>;
        case 'choice':
            return <span>{value.map((item) => (item.name)).join(', ')}</span>;
        case 'file':
            return <ThreadFile threadFile={value}/>;
        default:
            return null;
    }
};

Attribute.propTypes = {
    attribute: PropTypes.any.isRequired
};

class AttributesTable extends Component {

    render() {
        const filteredAttributes = AttributesTable.filterAttributes(this.props.attributes);
        const styles = this.getStyles(this.props.print);
        const id = 'attribute-table' + (this.props.print ? '-print' : '');

        return (
            <div id={id} style={{width: "auto"}}>
                {/* table width="100%" needed for export to word */}
                <table width="100%" className="attributes-table table table-sm" style={styles.table}>
                    <tbody>
                    {filteredAttributes.map(attribute => (
                        <tr key={attribute.id}>
                            <th style={styles.th}>{attribute.name}</th>
                            <td style={styles.td}><Attribute attribute={attribute}/></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    getStyles(print) {
        let styles = {
            table: {
            },
            th: {
                width: '30%',
            },
            td: {
                width: '70%',
            },
        };

        if (print) {
            styles.table = Object.assign({}, styles.table, {
                border: "1px solid white",
                background: '#f9f5f6',
                color: "#4b4a5c"
            });
            styles.th = Object.assign({}, styles.th, {background: '#cdc7b9'});
        }

        return styles;
    }

    static filterAttributes(attributes) {
        return attributes.filter((attribute) => attribute.value);
    }
}

AttributesTable.propTypes = {
    attributes: PropTypes.any.isRequired,
    print: PropTypes.bool
};

export default AttributesTable;
